<div class="notification-wrapper" 
     [@fade]="animationState"
     (@fade.done)="onAnimationDone($event)"
     [style.display]="isVisible ? 'inline-flex' : 'none'">
    <div class="notification-container">
        <div class="icon-container">
            <img [src]="icon | assetVersion" class="notification-icon"/>
        </div>
        <div class="notification-content">
            <span class="notification-title">{{ title }}</span>
            <span class="notification-description">{{ description }}</span>
        </div>
        <button class="close-button" (click)="onClose()" aria-label="Close notification">
            <img [src]="'svg/closeX.svg' | assetVersion"/>
        </button>
    </div>
</div>